export default __webpack_public_path__ + "static/media/we-wish-you-love-mobile.210a1ca3.webp";